function updateComingSoon (product, container) {
    if (product && product.comingSoon) {
        container.find('.comingSoonLabel').removeClass('hidden');
    } else {
        container.find('.comingSoonLabel').addClass('hidden');
    }
}

export function carouselPLP () {
    if ($('.cc-product-tile-carousel')) {
        $('.cc-product-tile-carousel').not('.cm-focus-carousel-swiper-container .cc-product-tile-carousel').each(function () {
            var $prevBtn = $(this).closest('.image-container').find('.js-image-nav--prev');
            var $nextBtn = $(this).closest('.image-container').find('.js-image-nav--next');

            $prevBtn.add($nextBtn).on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
            });

            if (!$(this).hasClass('slick-initialized')) {
                $(this).slick({
                    lazyLoad: 'ondemand',
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: $prevBtn,
                    nextArrow: $nextBtn,
                    responsive: [
                        {
                            breakpoint: 440,
                            settings: {
                                arrows: false
                            }
                        }
                    ]
                });
            }
        });
    }
}

class ProductBox {
    run () {
        this.changeVariation();
        this.afterAttributesSelectionEvent();
        this.gotoPDP();
        carouselPLP();
    }

    extractImageData (data, img) {
        for (let i = 0; i < data.length; i++) {
            img.url[i] = data[i].url;
            img.title[i] = data[i].title;
            img.imgsToShow[i] = data[i];
            img.resizedUrls[i] = '';
            if (img.imgsToShow[i].resizedUrls && img.imgsToShow[i].resizedUrls.length > 0) {
                for (let j = 0; j < img.imgsToShow[i].resizedUrls.length; j++) {
                    img.resizedUrls[i] += img.imgsToShow[i].resizedUrls[j] + ' ' + img.imgsToShow[i].sizes[j].scaleWidth + 'w,';
                }
                img.resizedUrls[i] = img.resizedUrls[i].substring(0, img.resizedUrls[i].length - 1);
            }
        }
    }

    setImages (imagesContainer, img) {
        for (let i = 0; i < imagesContainer.length; i++) {
            $(imagesContainer[i]).attr({
                src: img.url[i],
                alt: img.productName,
                title: img.title[i] ? img.title[i].trim() : img.productName,
                srcset: img.resizedUrls[i],
                sizes: window.LazyLoaderImage.sizes,
                itemprop: window.LazyLoaderImage.itemprop,
                loading: window.LazyLoaderImage.loading
            });
            if (window.LazyLoaderImage.width) {
                $(imagesContainer[i]).attr({
                    width: window.LazyLoaderImage.width,
                    height: window.LazyLoaderImage.height
                });
            }
        }
    }

    afterAttributesSelectionEvent () {
        $(document).on('product:afterAttributeSelect', (evt, additionalData) => {
            const $container = additionalData.container;

            if ($container.hasClass('product-quickview')) {
                return;
            }

            $container.find('.main-product-link').attr('href', additionalData.urls.pdpUrl);

            const $imageContainer = $container.find('.image-container');
            let $images = $imageContainer.find('.tile-image');
            let $video = $imageContainer.find('video');

            let imgData = {
                imgsToShow: [],
                url: [],
                title: [],
                resizedUrls: [],
                productName: additionalData.data.product.productName
            };

            const hasMediumImages = additionalData && additionalData.data && additionalData.data.product && additionalData.data.product.images && additionalData.data.product.images.medium;
            const hasLargeImages = additionalData && additionalData.data && additionalData.data.product && additionalData.data.product.images && additionalData.data.product.images.large;
            const hasVideos = additionalData && additionalData.data && additionalData.data.product && additionalData.data.product.plpVideo !== '';

            if (hasVideos) {
                // for switching from a product with only images to one with videos and images
                if ($video.length === 0 && $images.length > 1) {
                    $video = document.createElement('video');
                    $images[0].replaceWith($video);
                }
                $($video).attr({
                    width: '100%',
                    height: 'auto',
                    class: 'm-video js-video'
                });
                $video.autoplay = true;
                $video.muted = true;
                $video.playsInline = true;
                $video.loop = true;
                const source = document.createElement('source');
                source.src = additionalData.data.product.plpVideo;
                $video.append(source);
                $('body').trigger('observeVideoTracking');
            } else if ($video.length > 0) {
                // for switching from a product with videos and images to one with just images
                let image = document.createElement('img');
                image.setAttribute('class', 'tile-image tile-image--change');
                $imageContainer.prepend(image);
                $images = $imageContainer.find('.tile-image');
                $video.remove();
            }
            if (hasMediumImages) {
                this.extractImageData(additionalData.data.product.images.medium, imgData);
            } else if (hasLargeImages) {
                this.extractImageData(additionalData.data.product.images.large, imgData);
            }

            const $selectedSwatch = $container.find('.js-variation-product.selected');
            if ($selectedSwatch.length > 0) {
                const $specificTile = $selectedSwatch.closest('.product-tile');
                const ON_MODEL_IMAGE_INDEX = 0;
                const STILL_LIFE_IMAGE_INDEX = 1;

                if ($specificTile.hasClass('js-product-tile-still-life') && imgData.url.length > STILL_LIFE_IMAGE_INDEX) {
                    imgData.url[ON_MODEL_IMAGE_INDEX] = imgData.url[STILL_LIFE_IMAGE_INDEX];
                    imgData.resizedUrls[ON_MODEL_IMAGE_INDEX] = imgData.resizedUrls[STILL_LIFE_IMAGE_INDEX];
                }
            }

            this.setImages($images, imgData);

            if (additionalData.data.product.isInWishlist) {
                $container.find('.image-container .wishlistTile').addClass('added');
                if (additionalData.data.product.comingSoon) {
                    $container.find('.comingSoonBox .add-to-wish-list-coming-soon').addClass('hidden');
                }
            } else {
                $container.find('.image-container .wishlistTile').removeClass('added');

                if (additionalData.data.product.comingSoon) {
                    $container.find('.comingSoonBox .add-to-wish-list-coming-soon').removeClass('hidden');
                }
            }

            if (additionalData.data.product.isSoldout) {
                $container.find('.soldoutBox').removeClass('hidden');
            } else {
                $container.find('.soldoutBox').addClass('hidden');
            }

            $container.data('pid', additionalData.data.product.id);
            $container.find('.analytics.productListingItem').data('variant', additionalData.data.product.id.split('_')[2]);
            $container.find('.price-container').html(additionalData.data.product.price.html);
            $container.find('.js-pdp-link').map((idx, el) => $(el).attr('href', additionalData.urls.pdpUrl));
            $container.find('.js-wishlist-link').map((idx, el) => $(el).attr('href', additionalData.urls.wishlistUrl));
            $container.find('.js-quickview-link').map((idx, el) => $(el).attr('href', additionalData.urls.quickviewUrl));
            $container.find('.swatch-container').removeClass('selected');
            $container.find('.swatch-container[data-action-url*="' + additionalData.data.product.id + '"]').addClass('selected');
            updateComingSoon(additionalData.data.product, $container);
            this.showHidePromoMessages($container, additionalData.data);
            this.showHideQuickBuySizes($container, additionalData.data);
            var newPriceData = additionalData.data.product.price.html;
            if (additionalData.data.product.doubleCurrency && additionalData.data.product.doubleCurrency.html) {
                newPriceData += additionalData.data.product.doubleCurrency.html;
            }
            $container.find('.price-container').html(newPriceData);
            $('body').trigger('listing:changeVariant', {container: $container});
        });
    }

    showHideQuickBuySizes ($container, data) {
        $container.find('.quick-buy-sizes').addClass('hide');
        if (!data.product.comingSoon && !data.product.isSoldout && 'availableSizes' in data.product && data.product.availableSizes) {
            $container.find('.quick-buy-sizes').html(data.product.availableSizes.html);
            $container.find('.quick-buy-sizes').removeClass('hide');
        }
    }

    showHidePromoMessages ($container, data) {
        $container.find('.js-new-msg').addClass('hidden');
        $container.find('.js-promo-container').addClass('hidden');
        $container.find('.js-discount-msg, .js-discount-value-percentage').addClass('hidden');
        $container.find('.js-promo-msg').addClass('hidden');
        $container.find('.js-coming-soon-msg').addClass('hidden');
        $container.find('.js-coming-soon-msg').addClass('hidden');

        if (data.product.comingSoon) {
            $container.find('.js-coming-soon-msg').removeClass('hidden');
        } else if (data.product.soldout) {
            $container.find('.js-coming-soon-msg').removeClass('hidden');
        } else {
            $container.find('.js-promo-container').removeClass('hidden');

            if (data.product.New) {
                $container.find('.js-new-msg').removeClass('hidden');
            }
            if (data.product.price.discountValue) {
                $container.find('.js-discount-msg, .js-discount-value-percentage').html(data.product.price.discountValue + '%').removeClass('hidden');
            }
            if (data.product.promotions && data.product.promotions.length > 0) {
                $container.find('.js-promo-msg').html(data.product.promotions[0].name || data.product.promotions[0].id).removeClass('hidden');
            }
        }
    }

    gotoPDP () {
        $(document).on('click', '.product-tile', function (evt) {
            if (evt.target.classList.contains('js-prevent-link')) {
                evt.preventDefault();
            }
        });
        $(document).on('click', '.js-add-completePromo', function (evt) {
            if (evt.target.classList.contains('js-prevent-link')) {
                evt.preventDefault();
            }
        });
        $(document).on('click', '.cc-product-tile-carousel', function (evt) {
            if (evt.isDefaultPrevented()) {
                return;
            }
            if ($(evt.target).closest('.js-image-nav, .js-prevent-link').length) {
                return;
            }

            const href = $(this).closest('.product-tile').find('a.main-product-link').attr('href');
            if (!href) {
                return;
            }

            if (evt.ctrlKey || evt.metaKey || evt.button === 1) {
                window.open(href, '_blank');
            } else {
                window.location.href = href;
            }
        });
    }

    changeVariation () {
        $(document).on('click', '.js-variation-product', function (evt) {
            const $target = $(evt.currentTarget);
            const $productContainer = $target.closest('.product');
            const actionUrl = $target.data('actionUrl');
            const urls = {
                pdpUrl: $target.data('showUrl'),
                wishlistUrl: $target.data('wishlistUrl'),
                quickviewUrl: $target.data('quickviewUrl')
            };
            $target.parent().find('.js-variation-product').removeClass('selected');
            $target.addClass('selected');
            attributeSelect(actionUrl, urls, $productContainer);
        });

        $(document).on('keydown', '.js-variation-product', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
    }
}

const attributeSelect = (selectedValueUrl, urlsToUpdate, $productContainer) => {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect', {
            url: selectedValueUrl,
            container: $productContainer
        });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: data => {
                $('body').trigger('product:afterAttributeSelect', {
                    data: data,
                    container: $productContainer,
                    urls: urlsToUpdate
                });
                $('body').trigger('product:didChangeColorPLP', { sku: data.product.id });
                $.spinner().stop();
            },
            error: () => {
                $.spinner().stop();
            }
        });
    }
};

const productBox = new ProductBox();
export default productBox;

export const generatePromoAnimatedStrip = () => {
    $('.animation-identifier.promo-animated-strip').each(function () {
        const scrollingText = $(this).find('.pd-scrolling-text__content-text').html();
        let containerWidth;
        if ($(this).closest('.product-tile').length > 0) {
            containerWidth = $(this).closest('.product-tile').width();
        } else {
            containerWidth = $(this).closest('.pdpCarousel__slider-container').width();
        }
        const textWidth = $(this).find('.pd-scrolling-text__content-text').innerWidth();
        const cicleNumber = Math.ceil(containerWidth / (textWidth + 1));

        for (let i = 0; i < cicleNumber + 3; i++) {
            $(this).find('.pd-scrolling-text__content-text').append(scrollingText);
        }

        $(this).removeClass('animation-identifier');

        // Animation is added after the creation of the scrolling text, otherwise it breaks
        $(this).css({'visibility': 'visible', 'font-size': '0'})
            .find('.add-class-for-animation')
            .addClass('pd-scrolling-text__content-text-p')
            .removeClass('add-class-for-animation');

        // Calculate speed based on text width
        const animationDuration = textWidth * 10 / 160;
        $(this).find('.pd-scrolling-text__content-text-p').css('animation-duration', animationDuration + 's');
    });
};
